require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-landing-a-software-development-job.json") })
        }
      }, "path---blog-landing-a-software-development-job");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-landing-a-software-development-job!./.cache/json/blog-landing-a-software-development-job.json
// module id = 900
// module chunks = 231608221292675